import React from 'react'
import PropTypes from 'prop-types'
import {isEditing} from '@builder.io/sdk-react'
import {HERO_ROLES} from './cta.helper'
import {ToggleTextButton, buttonFunctions} from 'hec/components/cta'
import useLearningCenter from '~/app/hooks/use-learning-center'
import {computeHeroPrimary, getHeroOverrides} from './utils'

const HeroToggleTextButton = ({
    condition,
    conditionMetText,
    conditionNotMetText,
    stateToShowInEditor,
    clickFunction = buttonFunctions.linkToPage,
    attributes,
    heroRole,
    isRevShare,
    'data-testid': dataTestId,
    scrollTargetId
}) => {
    const {className: attrClassName, ...restAttributes} = attributes || {}
    const {learningCenterData, isLoading: lcLoading, error: lcError} = useLearningCenter()
    const isEdit = isEditing()
    if (lcLoading) return null
    if (lcError) console.warn('Learning Center data error; falling back to defaults', lcError)

    // Primary/secondary styling
    const heroPrimary = computeHeroPrimary(learningCenterData?.goals)
    const thisRole = heroRole === HERO_ROLES.CONTINUE ? HERO_ROLES.CONTINUE : HERO_ROLES.TAKE_QUIZ
    const computedVariant = thisRole === heroPrimary ? 'primary' : 'secondary'
    // URL overrides
    const overrides = getHeroOverrides(
        thisRole,
        learningCenterData?.activeLessonUrl,
        learningCenterData?.activeGoal,
        scrollTargetId
    )

    const finalRouteType = overrides?.routeType ?? null
    const finalUrl = overrides?.url ?? '' // let appendSearchParams build #id for element
    const clickHandler = overrides?.clickFunction ?? clickFunction

    return (
        <ToggleTextButton
            ctaType="button"
            condition={condition}
            conditionMetText={conditionMetText}
            conditionNotMetText={conditionNotMetText}
            stateToShowInEditor={stateToShowInEditor}
            variant={computedVariant}
            clickFunction={clickHandler}
            scrollTargetId={scrollTargetId}
            isRevShare={isRevShare}
            routeType={finalRouteType}
            url={finalUrl}
            isEdit={isEdit}
            className={attrClassName}
            {...restAttributes}
            data-testid={dataTestId || 'toggleTextButton-hero'}
        />
    )
}

export default HeroToggleTextButton

HeroToggleTextButton.propTypes = {
    condition: PropTypes.string.isRequired,
    conditionMetText: PropTypes.string.isRequired,
    conditionNotMetText: PropTypes.string.isRequired,
    stateToShowInEditor: PropTypes.string.isRequired,
    isLearningCenterHero: PropTypes.string,
    scrollTargetId: PropTypes.string,
    clickFunction: PropTypes.string,
    isRevShare: PropTypes.bool,
    attributes: PropTypes.object,
    'data-testid': PropTypes.string,
    heroRole: PropTypes.oneOf(['take_quiz', 'continue'])
}
